<template>
  <a
    class="toggle-icon"
    id="menu-toggle"
    aria-label="Toggle sidebar navigation"
    @click="toggleSideBar"
  >
    <span class="sr-only">Toggle sidebar navigation</span>
    <span class="icon-open">
      <fa icon="chevron-left"></fa>
    </span>
    <span class="icon-close">
      <fa icon="chevron-right"></fa>
    </span>
  </a>
</template>

<script>
import mixin from '../../utils/mixin';

export default {
  mixins: [mixin]
};
</script>

<style lang="scss" scoped>
.icon-open,
.icon-close {
  font-size: 21px;
}
</style>
